import { AllieIconProps } from '../../../components';

export const SquareOutlineIcon: React.FC<AllieIconProps> = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
